var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Edit_icon",
    "data-name": "Edit icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M2614,23.693a3,3,0,0,1-3-3v-13a3,3,0,0,1,3-3h4.5a1,1,0,0,1,0,2H2614a1,1,0,0,0-1,1v13a1,1,0,0,0,1,1h13a1,1,0,0,0,1-1v-4.5a1,1,0,1,1,2,0v4.5a3,3,0,0,1-3,3Zm3.3-6.226c-.781-.781-.041-5.322.739-6.1l7.779-7.778a2,2,0,0,1,2.829,0l2.474,2.475a2,2,0,0,1,0,2.828l-7.778,7.779c-.555.554-2.978,1.12-4.614,1.12A2.228,2.228,0,0,1,2617.3,17.466Zm2.258-4.793a7.892,7.892,0,0,0-.471,1.86,10.021,10.021,0,0,0-.117,1.247,10.083,10.083,0,0,0,1.221-.133,7.936,7.936,0,0,0,1.835-.493l4.357-4.356-2.476-2.475Zm5.764-5.765,2.475,2.476,1.909-1.91L2627.232,5Z",
    transform: "translate(-2609 -1.692)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4737976e.svg";
export { ForwardRef as ReactComponent };